<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import _ from "lodash";
import DownloadFile from "@/mixins/DownloadFile";
import Languages from "@/mixins/dictionaries/Languages";
// import VCurrencyInput from "@/components/commonComponents/VCurrencyInput.vue";

export default {
    name: "QuotesModalSvg",
    components: {
        // VCurrencyInput,
        AjaxLoad,
    },
    mixins: [
        DownloadFile,
        Languages,
    ],
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        idProject: {
            type: String,
        },
        idQuotes: {
            type: Number,
        },
        isDisabledField: {
            type: Function,
        },
        wasModified: {
            type: Boolean,
        },
    },
    data() {
        return {
            svg: null,
            // fontSizeInputOptions: {
            //     valueRange: {min: 1, max: 50},
            //     precision: 2,
            // },
            dictionaries: {
                speakers: [],
                sessions: [],
                sessionsTitles: [],
            },
            isLoadingSvg: false,
            isLoadingPng: false,
        };
    },
    computed: {
        speakerBitrixPhoto() {
            if (!this.speaker) {
                return undefined;
            }
            return this.speaker?.photo ? this.getSrc(this.speaker.photo) : null
        },
        speakerPhoto() {
            return this.value.photo ?
                this.$apiUrl.getFullUrl(this.value.photo) + this.$apiUrl.getQueryString(this.value?.photo_crop) :
                this.speakerBitrixPhoto;
        },
        aiTextLanguage() {
            return _.find(this.dictionaries.languages, {id: this.value.language}).quotesSvgAiText;
        },
        changeHrefFnDebounced() {
            return _.debounce(this.changeHrefFn, 1000);
        },
        quotes() {
            if (this.language === 'en') {
                return {
                    lq: '“',
                    rql: '”',
                    rq: '.”',
                };
            }
            return {
                lq: '«',
                rql: '»',
                rq: '».',
            };
        },
        dataForSvgReplace() {
            const value = this.value,
                changeTextFn = (text, size) => {
                    return (el) => {
                        el.textContent = text;
                        el.style.fontSize = size ? size + 'px' : null;
                        el.classList.toggle('default', !size);
                    }
                },
                changeHrefFn = (href) => {
                    return (el) => this.changeHrefFnDebounced(el, href);
                },
                quotes = this.quotes,
                speakerPosition = this.language === 'en' ? this.typografQuotes(value.speaker_position) : value.speaker_position,
                text = _.isNil(value.text) ? '' :
                    [
                        quotes.lq,
                        value.text,
                        quotes.rq,
                    ].join('');
            return {
                speakerName: changeTextFn(this.speakerName, value.svg_speaker_name_font_size),
                speakerPosition: changeTextFn(speakerPosition, value.svg_speaker_position_font_size),
                speakerPhoto: changeHrefFn(this.speakerPhoto),
                text: changeTextFn(text, value.svg_text_font_size),
                sessionNameAndDate: (el) => {
                    const size = value.svg_session_name_font_size,
                        sessionTitlesClassPrefix = 'sessions-titles-';
                    el.style.fontSize = size ? size + 'px' : null;
                    el.classList.toggle('default', !size);
                    Array
                        .from(el.classList)
                        .filter(v => _.startsWith(v, sessionTitlesClassPrefix))
                        .forEach(v => el.classList.remove(v))
                    el.classList.add([sessionTitlesClassPrefix, value.id_sessions_titles || 0].join(''));
                },
                sessionName: changeTextFn(this.sessionNameWithTitle, value.svg_session_name_font_size),
                sessionDate: changeTextFn(this.sessionDate, value.svg_session_name_font_size),
                isAI: changeTextFn(value.is_ai ? this.aiTextLanguage : '', value.svg_ai_font_size),
            };
        },
        language() {
            return this.value?.language || 'ru';
        },
        speaker() {
            return _.find(this.dictionaries.speakers, {id_speaker_eps: this.value?.id_speaker});
        },
        speakerName() {
            return this.speaker?.['name_' + this.language];
        },
        sessionsOrderedByActiveDesc() {
            return _.orderBy(this.dictionaries.sessions, ['is_active'], ['desc']);
        },
        session() {
            return _.find(this.sessionsOrderedByActiveDesc, {id_session_eps: this.value?.id_session_eps});
        },
        sessionName() {
            return this.session?.['name_' + this.language] || this.session?.['name'];
        },
        sessionDate() {
            const dateTemplate = this.language === 'ru' ? 'D MMMM Y г.': 'D MMMM Y';
            return this.session?.start ? this.$moment(this.session?.start).locale(this.language).format(dateTemplate) : '';
        },
        sessionTitle() {
            return _.find(this.dictionaries.sessionsTitles, {id: this.value?.id_sessions_titles});
        },
        sessionNameWithTitle() {
            const sessionTitle = this.sessionTitle,
                sessionName = this.sessionName ?
                    [
                        sessionTitle?.['prefix_' + this.language] ? sessionTitle?.['prefix_' + this.language] + ' ' : '',
                        sessionTitle ? this.quotes.lq : '',
                        this.sessionName,
                        sessionTitle ? this.quotes.rql : '',
                    ]
                        .join('')
                        .replace(new RegExp(this.quotes.lq + '+', 'g'), this.quotes.lq)
                        .replace(new RegExp(this.quotes.rql + '+', 'g'), this.quotes.rql)
                    :
                    null;
            return sessionName;
        },
        svgUrl() {
            return this.$apiUrl.getQuoteSvgFullUrl({id_project: this.idProject, id: this.idQuotes});
        },
    },
    watch: {
        dataForSvgReplace() {
            this.replaceDataInSvg();
        },
        svg() {
            this.$nextTick(() => {
                this.replaceDataInSvg();
            });
        },
    },
    methods: {
        replaceDataInSvg: _.debounce(function () {
            const svg = this.$refs.svg;
            if (svg) {
                _.each(this.dataForSvgReplace, (changeFn, id) => {
                    const el = svg.querySelector('#' + id);
                    if (el) {
                        changeFn(el);
                    }
                });
            }
        }, 400),
        // @TODO: mixin
        getSrc(file) {
            return [process.env.VUE_APP_ROSCONGRESS_URL, 'upload', file].join('/');
        },
        onClickDownloadSvg() {
            this.isLoadingSvg = true;
            this.getFile(this.svgUrl)
                .finally(() => {
                    this.isLoadingSvg = false;
                });
        },
        async onClickDownloadPng() {
            this.isLoadingPng = true;
            try {
                const response = await this.$api.request({
                    url: this.svgUrl,
                    method: 'GET',
                    responseType: 'text',
                });

                // SVG в DOM
                const svgDoc = new DOMParser().parseFromString(response.data, 'image/svg+xml');
                const svgElement = svgDoc.querySelector('svg');
                if (!svgElement) {
                    throw new Error('SVG element not found');
                }

                // Убираем фон
                svgElement.classList.add('no-bg');

                // Определяем размеры и если нужно масштабируем для высокого разрешения
                const scale = 4;
                const viewBox = (svgElement.getAttribute('viewBox') || '').split(/[\s,]+/);
                const width = (viewBox.length === 4 && parseFloat(viewBox[2])) || parseFloat(svgElement.getAttribute('width')) || 1000;
                const height = (viewBox.length === 4 && parseFloat(viewBox[3])) || parseFloat(svgElement.getAttribute('height')) || 1000;

                svgElement.setAttribute('width', width * scale);
                svgElement.setAttribute('height', height * scale);

                // SVG в Canvas
                /*
                const svgBlob = new Blob(
                    [new XMLSerializer().serializeToString(svgElement)],
                    {type: 'image/svg+xml;charset=utf-8'},
                );
                const blobUrl = URL.createObjectURL(svgBlob);
                 */

                const img = await new Promise((resolve, reject) => {
                    const image = new Image();
                    image.crossOrigin = "anonymous";
                    image.onload = () => resolve(image);
                    image.onerror = reject;

                    // image.src = blobUrl;
                    /**
                     * Решение SecurityError: Failed to execute 'toDataURL' on 'HTMLCanvasElement': Tainted canvases may not be exported.
                     * @link https://stackoverflow.com/questions/32735822/tainted-canvas-with-canvas-toblob
                     * @link https://issues.chromium.org/issues/41054640
                     * @link https://jsfiddle.net/2Lh24rg9/
                     */
                    image.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent((new XMLSerializer()).serializeToString(svgElement));
                });

                const canvas = document.createElement('canvas');
                canvas.width = width * scale;
                canvas.height = height * scale;
                canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);

                // Скачиваем PNG
                canvas.toBlob((blob) => {
                    if (blob) {
                        const downloadUrl = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = `quote-${this.idQuotes || 'image'}.png`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(downloadUrl);
                    }
                    // URL.revokeObjectURL(blobUrl);
                }, 'image/png');

            } catch (error) {
                console.error('Error downloading PNG:', error);
            } finally {
                this.isLoadingPng = false;
            }
        },
        changeHrefFn(el, href) {
            if (href === undefined) {
                return;
            }
            el.onerror = function () {
                this.setAttribute('href', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM88R8AApUByU2MEcEAAAAASUVORK5CYII=');
            }
            el.setAttribute('href', href);
        },
        typografQuotes(text) {
            const beforeLeft = ' \n\t\u00a0[(',
                afterRight = ' \n\t\u00a0!?.:;#*,…)\\]',
                //quotes = '«‹»›„“‟”"',
                quotes = '"',
                privateLabel = '\uF000',
                reL = new RegExp('(^|[' + beforeLeft + '])([' + quotes + ']+)(?=[^\\s' + privateLabel + '])', 'gim'),
                reR = new RegExp( '([^\\s' + privateLabel + '])([' + quotes + ']+)(?=[' + afterRight + ']|$)', 'gim'),
                replaceQuotes = this.quotes;

            return text
                .replace(reL, function ($0, $1, $2) { return $1 + replaceQuotes.lq.repeat($2.length); })
                .replace(reR, function ($0, $1, $2) { return $1 + replaceQuotes.rq.repeat($2.length); });
        },
    }
}
</script>

<template>
    <div>
        <ajax-load
            :url="svgUrl"
            :transform="response => response.data"
            v-model="svg"
            v-slot="{resolved}"
        >
            <v-card class="svg-preview">
                <v-card-text class="pa-4">
                    <v-skeleton-loader
                        class="mx-auto"
                        max-width="100%"
                        type="image"
                        v-if="!resolved"
                    ></v-skeleton-loader>
                    <div v-html="svg" ref="svg" class="svg" v-if="resolved"></div>
                </v-card-text>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="wasModified"
                        :loading="isLoadingPng || !resolved"
                        @click="onClickDownloadPng"
                        class="mr-2"
                    >
                        Скачать PNG
                    </v-btn>
                    <v-btn
                        :disabled="wasModified"
                        :loading="isLoadingSvg || !resolved"
                        @click="onClickDownloadSvg"
                    >
                        Скачать SVG
                    </v-btn>
                </v-card-actions>
            </v-card>
        </ajax-load>

        <ajax-load
            v-model="dictionaries.speakers"
            :url="$apiUrl.getProjectDictionarySpeakersUrl({id_project: idProject})"
            :transform="response => response.data.data"
        ></ajax-load>
        <ajax-load
            v-model="dictionaries.sessions"
            :url="$apiUrl.getProjectDictionarySessionsUrl({id_project: idProject})"
            :transform="response => response.data.data"
        ></ajax-load>
        <ajax-load
            v-model="dictionaries.sessionsTitles"
            :url="$apiUrl.getProjectDictionarySessionsTitlesUrl({id_project: idProject})"
            :transform="response => response.data.data"
        ></ajax-load>
    </div>
</template>

<style scoped lang="scss">
::v-deep {
    .svg-preview {
        .svg {
            line-height: 0;
            width: 100%;
            height: 100%;
        }
        .v-card__text {
            aspect-ratio: 1;
            width: 100%;
            height: 100%;
            position: relative;
        }
        .v-card__actions {
            border-top: 1px solid silver;
        }
        .v-skeleton-loader {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 999;
        }
        .v-skeleton-loader__bone {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
